export default __webpack_public_path__ + "static/4-212e0ac22af10f4e57979eaa56aea26a.jpeg";